import { useDynamicConfig } from '@statsig/react-bindings';
import { useMemo } from 'react';

import { retryConfigForClientMissingRequiredConsentsQuery } from './statsig/gates';

export const DEFAULT_QUERY_RETRY_CONFIG = {
  retries: 3,
  initialDelayMs: 500,
  backoffFactor: 2,
};

/** Hook for retrieving dynamic config values for retrying failed queries. */
export function useQueryRetryConfig() {
  const rawRetryConfig = useDynamicConfig(retryConfigForClientMissingRequiredConsentsQuery);
  const retries = rawRetryConfig.get('retries', DEFAULT_QUERY_RETRY_CONFIG.retries);
  const initialDelayMs = rawRetryConfig.get('initial_delay_ms', DEFAULT_QUERY_RETRY_CONFIG.initialDelayMs);
  const backoffFactor = rawRetryConfig.get('backoff_factor', DEFAULT_QUERY_RETRY_CONFIG.backoffFactor);
  return useMemo(() => {
    return { retries, initialDelayMs, backoffFactor };
  }, [retries, initialDelayMs, backoffFactor]);
}
